<div class="row options-container">
    <div *ngFor="let option of (asObservable(to.options) | async)">
        <mat-checkbox [formlyAttributes]="field" [checked]="isChecked(option.value)"
            [disabled]="formControl.disabled || getOptionIsDisabled(option.value)" [matTooltip]="option.tooltip"
            (change)="onChange(option.value, $event.checked)">
            {{ option.label }}
        </mat-checkbox>
    </div>
</div>